export default __webpack_public_path__ + "static/media/icn_to_blk.e29cbbb8.svg";